import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imagePath'
})
export class ImagePathPipe implements PipeTransform {
  transform(path: string): string {
    if (!path) return '';

    // Check if the path contains double URL pattern
    if (path.includes('//storage/https://')) {
      // Extract everything after //storage/
      return path.split('//storage/')[1];
    }

    return path;
  }
}
